import { useEffect, useReducer } from 'react';
import { IDexTrade, IWalletStats } from '@kattana-io/common';
import { KattanaAPI } from '../../../store/createStore';

enum InfoActionKind {
  setState = 'set_state',
  setLoading = 'loading',
  setErrorNoTrades = 'error_no_trades',
  setServerError = 'server_error',
}

type WalletInfoState = {
  trades: IDexTrade[] | [];
  stats: IWalletStats | null;
  loading: boolean;
  isErrorNoTrades: boolean;
  isServerError: boolean;
};

type WalletInfoAction = {
  type: InfoActionKind;
  payload: any;
};

const initState: WalletInfoState = {
  trades: [],
  stats: null,
  loading: false,
  isErrorNoTrades: false,
  isServerError: false,
};

const reducer = (state: any, action: WalletInfoAction) => {
  const { type, payload } = action;
  switch (type) {
  case 'set_state': {
    return { ...state, ...payload };
  }
  case 'loading': {
    return { ...state, loading: payload };
  }
  case 'error_no_trades': {
    return { ...state, isErrorNoTrades: payload };
  }
  case 'server_error': {
    return { ...state, isServerError: payload };
  }
  }
};

const useWalletInfo = (data: any): WalletInfoState => {
  const [state, dispatch] = useReducer(reducer, initState);

  const { address, chain, wallet, timeframe } = data;

  useEffect(() => {
    const controller = new AbortController();
    if (!state.loading) {
      dispatch({ type: InfoActionKind.setLoading, payload: true });
      KattanaAPI.walletInfo(
        address,
        chain,
        wallet,
        timeframe,
        data.date,
        controller
      )
        .then((data) => {
          const info = data as any;

          if (!info) {
            dispatch({ type: InfoActionKind.setServerError, payload: true });
          } else if (info.error) {
            dispatch({
              type: InfoActionKind.setErrorNoTrades,
              payload: true,
            });
          }

          const trades = info.trades || [];
          const stats = info.stats || {};
          dispatch({
            type: InfoActionKind.setState,
            payload: {
              trades,
              stats,
              isServerError: false,
              isErrorNoTrades: false,
            },
          });
        })
        .catch((error) => {
          dispatch({ type: InfoActionKind.setServerError, payload: true });
          console.error(error);
        })
        .finally(() =>
          dispatch({ type: InfoActionKind.setLoading, payload: false })
        );
    }

    return () => {
      controller.abort();
    };
  }, [timeframe]);

  return state;
};

export default useWalletInfo;
